import { call, ForkEffect, put, select, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { benchmark } from 'shared/containers/App/saga';
import getEicMessagesAsync, { GetEicMessagesResponse } from 'shared/providers/requests/cart/getEicMessages';
import { generateError } from 'shared/views/Cart/saga';
import { consentActions } from './slice';
import updateConsentAsync from 'shared/providers/requests/cart/updateConsent';
import { updateConsentRest } from 'shared/providers/requests/cart/updateConsentRest';
import { UpdateConsentInput } from '@buy-viasat/types/build/bv';
import { navActions } from '@buy-viasat/redux/src/navigator';
import { selectCartId } from '@buy-viasat/redux/src/cart';
import { appActions, Modals } from '@buy-viasat/redux/src/app';
import { adobeTargetDataLayer } from 'shared/containers/Analytics';
import { DataLayerEvents, CustomDataLayerEvents } from 'shared/containers/Analytics/types';
import { USE_NEW_API } from 'shared/utils/dataFetchingHooks/constants';

export function* getEicMessagesSaga(): Generator {
  const cartId: string = yield select(selectCartId);

  try {
    const response: GetEicMessagesResponse = yield call(getEicMessagesAsync, { input: { cartId } });
    const eicMessages = response.data?.getEicMessages;

    adobeTargetDataLayer.push({
      event: DataLayerEvents.AA_EVENT,
      eventData: {
        event: CustomDataLayerEvents.DISCLOSURES,
      },
    });

    yield put(consentActions.setEicMessages(eicMessages));
  } catch (err: any) {
    yield call(generateError, err, 'getEicMessagesSaga');
    yield put(consentActions.setEicMessagesError(true));
  }
}

export function* updateConsent(action: PayloadAction<UpdateConsentInput>) {
  try {
    if (USE_NEW_API) {
      yield call(updateConsentRest, action.payload);
    } else {
      yield call(updateConsentAsync, {
        input: action.payload,
      });
    }

    yield put(navActions.next());
    yield put(consentActions.updateConsentLoading(false));
  } catch (err: any) {
    yield put(consentActions.updateConsentLoading(false));
    yield put(appActions.setErrorRetryAction({ type: consentActions.setUpdateConsent.type, payload: action.payload }));
    yield put(appActions.setModalVisible(Modals.ERROR));
    yield call(generateError, err, 'updateConsent');
  }
}

export function* consentSaga(): Generator<ForkEffect, void, void> {
  yield takeLatest(consentActions.getEicMessages.type, benchmark(getEicMessagesSaga));
  yield takeLatest(consentActions.setUpdateConsent.type, benchmark(updateConsent));
}
